<template>
  <div class="hold-transition">
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Islas</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item active">Administración</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Lugar</li>
                  <li class="breadcrumb-item active">Islas</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal_form_sitio_export"
                        v-if="$store.getters.can('argentina.sitios.export')"
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="create()"
                        v-if="$store.getters.can('argentina.sitios.create')"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body p-0">
                <table
                  id="users"
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead>
                    <tr class="text-center">
                      <th>
                        ID
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.id"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Código Alterno
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.codigo"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Nombre
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.nombre"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Sigla
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.sigla"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Departamento
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="filtros.departamento"
                          label="descripcion"
                          :options="listasForms.departamentos"
                          @input="getIndex()"
                        ></v-select>
                      </th>
                      <th>
                        Ciudad
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="filtros.ciudad"
                          label="nombre"
                          :options="listasForms.ciudades"
                          @input="getIndex()"
                        ></v-select>
                      </th>
                      <th>
                        Estado
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th class="align-middle">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in sitios.data" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.codigo }}</td>
                      <td>{{ item.nombre }}</td>
                      <td>{{ item.sigla }}</td>
                      <td>
                        {{
                          item.departamento ? item.departamento.descripcion : ""
                        }}
                      </td>
                      <td>{{ item.ciudad.nombre }}</td>
                      <td class="text-center">
                        <span
                          class="badge"
                          data-toggle="modal"
                          data-target="#modal-form-estado"
                          style="cursor: pointer"
                          v-bind:class="[
                            item.estado == 1 ? 'badge-success' : 'badge-danger',
                          ]"
                          v-if="
                            $store.getters.can(
                              'argentina.sitios.actualizarEstado',
                            )
                          "
                          @click="llenarModal(item.id, item.estado)"
                        >
                          {{ item.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                        </span>
                        <span
                          v-else
                          class="badge"
                          v-bind:class="[
                            item.estado == 1 ? 'badge-success' : 'badge-danger',
                          ]"
                        >
                          {{ item.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                        </span>
                      </td>

                      <td style="width: 50px">
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            v-if="$store.getters.can('argentina.sitios.edit')"
                            @click="edit(item)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            v-if="$store.getters.can('argentina.sitios.delete')"
                            @click="destroy(item.id)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="sitios.total">
                  <p>
                    Mostrando del <b>{{ sitios.from }}</b> al
                    <b>{{ sitios.to }}</b> de un total:
                    <b>{{ sitios.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="sitios"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
        <SitioEstado ref="SitioEstado" />
      </div>
    </div>
    <SitioExport ref="SitioExport" />
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import pagination from "laravel-vue-pagination";
import SitioEstado from "./SitioEstado";
import SitioExport from "./SitioExport";

export default {
  name: "Sitios",
  components: {
    pagination,
    vSelect,
    SitioEstado,
    SitioExport,
  },
  data() {
    return {
      filtros: {
        id: null,
        nombre: null,
        codigo: null,
        sigla: null,
        departamento: null,
        ciudad: null,
        estado: null,
        pais_id: 3,
      },
      sitios: {},
      listasForms: {
        departamentos: [],
        ciudades: [],
        estados: [],
      },
    };
  },
  methods: {
    getIndex(page = 1) {
      axios
        .get("/api/argentina/sitios?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.sitios = response.data;
        });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getDepartamentos() {
      axios
        .get("/api/argentina/departamentos/lista", {
          params: { pais_id: 3 },
        })
        .then((response) => {
          this.listasForms.departamentos = response.data;
        });
    },

    getCiudades() {
      axios
        .get("/api/argentina/ciudades/lista", {
          params: { pais_id: 3 },
        })
        .then((response) => {
          this.listasForms.ciudades = response.data;
        });
    },

    destroy(idSitio) {
      this.$swal({
        title: "Esta seguro de eliminar este Sitio?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, ElimInar!",
      }).then((result) => {
        // <--
        if (result.value) {
          axios.delete("/api/argentina/sitios/" + idSitio).then(() => {
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "Se elimino el Sitio exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          });
        }
      });
    },

    llenarModal(id, estado) {
      this.$refs.SitioEstado.llenar_modal(id, estado);
    },

    create() {
      return this.$router.push({
        name: "/Argentina/Admin/SitioForm",
        params: { accion: "Crear" },
      });
    },

    edit(sitio) {
      return this.$router.push({
        name: "/Argentina/Admin/SitioForm",
        params: { accion: "Editar", data_edit: sitio },
      });
    },
  },

  mounted() {
    this.getIndex();
    this.getEstados();
    this.getDepartamentos();
    this.getCiudades();
  },
};
</script>
